import { api, buildQueryParams, URLs } from '@/libs/api'
import type {
  ApiResponse,
  CreateOvertimePayload,
  OvertimeListParams,
  OvertimeRecord,
} from '@/libs/interfaces'

const overtimesApiReal = {
  create: async (
    employeeID: string,
    storeID: string,
    payload: CreateOvertimePayload,
  ): Promise<OvertimeRecord> => {
    return await api
      .post<ApiResponse<OvertimeRecord>>(URLs.Overtimes.create(employeeID, storeID), payload)
      .then((res) => res.data.data)
  },

  listByStore: async (params: OvertimeListParams): Promise<OvertimeRecord[]> => {
    const { storeID, ...queryParams } = params
    const query = buildQueryParams(queryParams)
    return await api
      .get<ApiResponse<{ overTimes: OvertimeRecord[] }>>(URLs.Overtimes.listByStore(storeID, query))
      .then((res) => res.data.data.overTimes ?? [])
  },
}

export const overtimesApi = overtimesApiReal
